import { buildQueryString, request } from "../client"
import type { OrganizationOnboardingResponse } from "../organization-onboarding"
import type { TutorialResponse } from "../tutorials"

export type HomeDashboardSectionState = "READY" | "HIDDEN" | "ERROR"

export type HomeDashboardSection<T> = {
  state: HomeDashboardSectionState
  data: T | null
}

export type HomeDashboardTaskTile = {
  key: string
  label: string
  group: string
  count: number
  icon: string
  priority: number
}

export type HomeDashboardCommunicationPoint = {
  date: string
  outbound: number
  inbound: number
}

export type HomeDashboardWorkOrderStatusShare = {
  status: string
  label: string
  count: number
}

export type HomeDashboardResponse = {
  tutorial: HomeDashboardSection<TutorialResponse>
  onboarding: HomeDashboardSection<OrganizationOnboardingResponse>
  tasks: HomeDashboardSection<{
    task_tiles: HomeDashboardTaskTile[]
  }>
  statistics: HomeDashboardSection<{
    communication_points: HomeDashboardCommunicationPoint[]
    work_order_status_share: HomeDashboardWorkOrderStatusShare[]
  }>
}

export type FetchHomeDashboardParams = {
  startDate: string
  endDate: string
}

export const fetchHomeDashboard = (
  organizationId: string,
  params: FetchHomeDashboardParams,
  options: { signal?: AbortSignal } = {},
): Promise<HomeDashboardResponse> =>
  request<HomeDashboardResponse>(
    `/organizations/${encodeURIComponent(organizationId)}/home-dashboard${buildQueryString({
      start_date: params.startDate,
      end_date: params.endDate,
    })}`,
    { signal: options.signal },
  )
